// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__IHH0L","breadcrumbs":"Orders_breadcrumbs__bxB92","heading-wrapper":"Orders_heading-wrapper__6tUmF"};